// Associations (Craig, 1 Nov 2026; steps 2.44, 2.45; docs/CRM_TOOLS.md "Network pages"): where the business's buyers
// gather, as three browse-only tabs over the central industry database: Events (fairs, trade events, awards and
// courses, as a list or a calendar), Networks (associations, registers, courses, communities, media and voices) and
// Partners (firms that already sell to the same buyers). Ranked by rules with their reasons shown. The old automated
// events workflow stays paused under the Network module (./network.tsx).
// Screens are loaded with screen() (see ./screen.ts), never imported directly.
import type { SteppedModule } from "./types";
import { screen } from "./screen";

const EventsPage = screen(() => import("../screens/associations/Events"), "AssociationsEventsPage");
const NetworksPage = screen(() => import("../screens/associations/Networks"), "AssociationsNetworksPage");
const PartnersPage = screen(() => import("../screens/associations/Partners"), "AssociationsPartnersPage");

export const associations: SteppedModule = {
  key: "associations",
  label: "Associations",
  layout: "steps",
  tabs: [
    { key: "events", label: "Events", pages: [{ slug: "", label: "Events", step: "2.44", render: () => <EventsPage /> }] },
    {
      key: "networks",
      label: "Networks",
      pages: [{ slug: "", label: "Networks", step: "2.44", render: () => <NetworksPage /> }],
    },
    {
      key: "partners",
      label: "Partners",
      pages: [{ slug: "", label: "Partners", step: "2.45", render: () => <PartnersPage /> }],
    },
  ],
  taskHomes: {},
};
